import DOMPurify from 'dompurify';

interface SafeHtmlContentProps {
  html: string;
  className?: string;
  allowedTags?: string[];
  allowedAttributes?: { [key: string]: string[] };
}

/**
 * SafeHtmlContent component that sanitizes HTML content to prevent XSS attacks
 * Uses DOMPurify for robust HTML sanitization
 */
export const SafeHtmlContent = ({ 
  html, 
  className = "",
  allowedTags = [
    'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'strong', 'em', 'u', 'ul', 'ol', 'li', 
    'a', 'br', 'span', 'div', 'blockquote', 'pre', 'code'
  ],
  allowedAttributes = {
    'a': ['href', 'title', 'target'],
    'span': ['class'],
    'div': ['class'],
    'p': ['class'],
    'h1': ['class'],
    'h2': ['class'],
    'h3': ['class'],
    'h4': ['class'],
    'h5': ['class'],
    'h6': ['class']
  }
}: SafeHtmlContentProps) => {
  const sanitizedHtml = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: Object.values(allowedAttributes).flat(),
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
    FORBID_TAGS: ['script', 'object', 'embed', 'style', 'form', 'input'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'onchange', 'onsubmit']
  });

  return (
    <div 
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};